import {
  LOADING_WITH_TEXT,
  SCHEDULE_CALL,
} from 'src/pages/scheduleCallback/constants/views';
import {cancelAppointmentStep} from 'src/pages/scheduleCallback/store/actions/cancelAppointmentStep';
import {errorStep} from 'src/pages/scheduleCallback/store/actions/errorStep';
import {selectIntentStep} from 'src/pages/scheduleCallback/store/actions/selectIntentStep';
import {
  LOAD_TIMESLOTS_COMPELTE,
  loadTimeslots,
} from 'src/pages/scheduleCallback/store/actions/timeslots';
import {
  hasAppointment,
  intent,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {unavailableStep} from 'src/pages/scheduleCallback/store/actions/unavailableStep';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {waitUntil} from 'src/shared/events';
import {pushHistory} from 'src/shared/history/actions';
import {resourceStatus} from 'src/shared/resourceStatus/selectors';
import {unavailableIntents} from '../../../../shared/constants/scheduleCallbackIntents';

export const selectTimeslotStep = () => async (dispatch, getState) => {
  if (hasAppointment(getState())) {
    return dispatch(cancelAppointmentStep());
  }
  if (!intent(getState())) {
    return dispatch(selectIntentStep());
  }
  dispatch(changeView(LOADING_WITH_TEXT));
  dispatch(loadTimeslots(intent(getState())));
  await waitUntil(LOAD_TIMESLOTS_COMPELTE);
  if (resourceStatus(getState()).error.timeslots) {
    return dispatch(errorStep());
  }
  if (unavailableIntents.includes(intent(getState()))) {
    return dispatch(unavailableStep());
  }
  dispatch(changeView(SCHEDULE_CALL));
  dispatch(pushHistory(selectTimeslotStep(), fragment('time')));
  logScreenName(`time|${intent(getState())}`);
};
